import React,{ Component } from 'react';
import {Row, Col, Button, ButtonGroup } from 'react-bootstrap';
import FieldGroup from '../../../../components/FieldGroup';
import { handleFieldChange } from "../../../../Utils";


class SearchForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            search: ''
        };

        this.handleFieldChange = handleFieldChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleReset = this.handleReset.bind(this);
    }

    handleFormSubmit() {
        this.props.onSubmit(this.state.search);
    }

    handleReset() {
        this.setState({ search: '' });
        this.props.onReset();
    }

    render() {
        return (
            <form>
                <Row>
                    <Col lg={4}>
                        <FieldGroup
                            type="еуче"
                            name="search"
                            label="Affid:"
                            onChange={this.handleFieldChange}
                            value={this.state.dateFrom}
                        />
                    </Col>

                </Row>

                <ButtonGroup>
                    <Button type="button" bsStyle="info" className="m-b-15 m-r-15" onClick={this.handleFormSubmit}>Search</Button>
                    <Button type="button" bsStyle="info" className="m-b-15 m-r-15" onClick={this.handleReset}>Reset</Button>
                </ButtonGroup>
            </form>
        );
    }
}

export default SearchForm;



// WEBPACK FOOTER //
// ./src/scenes/Payouts/components/SearchForm/index.js